<form-control-container #container [control]="controlInstance" [class.readonly]="isReadonlyValue">

    <div label-extension>
        <ng-content select="[label-extension]"></ng-content>
    </div>
    <ng-container *ngIf="!isReadonlyValue">

        <div class="input-group">
            <ng-content select="[before]"></ng-content>

            <div class="input-container">
                <!-- <input [(colorPicker)]="value" [(ngModel)]="value" type="text" class="form-control" [ngClass]="{invalid: invalid}"
                [id]="controlId" [disabled]="disabled" (focusout)="touch();" [attr.maxlength]="25"
                [attr.placeholder]="placeholder" [attr.tabindex]="tabindex" /> 
                COLOR PICKER WAS REMOVED FROM HTML LIBRARY IS NOT AVAILABLE ANGULAR CHANGES
                -->
                <input [(ngModel)]="value" type="text" class="form-control" [ngClass]="{invalid: invalid}"
                    [id]="controlId" [disabled]="disabled" (focusout)="touch();" [attr.maxlength]="25"
                    [attr.placeholder]="placeholder" [attr.tabindex]="tabindex" />

                <span class="colors-swatch" *ngIf="value">
                    <span class="colors-swatch-color" [style.background]="value"></span>
                </span>
            </div>
            <ng-content select="[after]"></ng-content>
        </div>
    </ng-container>
    <ng-container *ngIf="isReadonlyValue">
        <span class="readonly-value">{{value}}</span>
    </ng-container>

</form-control-container>